import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "NcVNodes",
  props: {
    /**
     * The vnodes to render
     */
    vnodes: {
      type: [Array, Object],
      default: null
    }
  },
  /**
   * The render function to display the component
   */
  render() {
    return this.vnodes || this.$slots?.default?.({});
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcVNodes.vue_vue_type_script_lang.mjs.map
